import { createContext } from 'react';
import { User, Session } from '@supabase/supabase-js';

// ============================================================================
// TYPES & INTERFACES
// ============================================================================

export interface Profile {
    id?: string;
    user_id: string;
    full_name: string;
    email?: string;
    avatar_url: string | null;
    is_verified?: boolean;
    created_at?: string;
    updated_at?: string;
}

export interface AuthContextType {
    user: User | null;
    session: Session | null;
    profile: Profile | null;
    loading: boolean;
    isAdmin: boolean;
    hasActiveSubscription: boolean;
    isEmailVerified: boolean;
    subscriptionLoaded: boolean;
    roleLoaded: boolean;
    signIn: (email: string, pass: string) => Promise<{ error: Error | null }>;
    signUp: (email: string, pass: string, name: string) => Promise<{ error: Error | null }>;
    signOut: () => Promise<void>;
    refreshProfile: () => Promise<void>;
    verifyEmailCode: (code: string, userId?: string, email?: string, password?: string) => Promise<{ error: Error | null }>;
    resendVerificationCode: (email: string, userId?: string) => Promise<{ error: Error | null }>;
}

export const AuthContext = createContext<AuthContextType>({
    user: null,
    session: null,
    profile: null,
    loading: true,
    isAdmin: false,
    hasActiveSubscription: false,
    isEmailVerified: false,
    subscriptionLoaded: false,
    roleLoaded: false,
    signIn: async () => ({ error: null }),
    signUp: async () => ({ error: null }),
    signOut: async () => { },
    refreshProfile: async () => { },
    verifyEmailCode: async () => ({ error: null }),
    resendVerificationCode: async () => ({ error: null }),
});
